import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useMediaQuery, useTheme } from "@mui/material";
import SignInPage from "./components/SignInPage";
import RegistrationPage from "./components/RegistrationPage";
import ProfilePage from "./components/ProfilePage";
import Header from "./components/Header"; // Import your Header component
import LandingPage from "./components/LandingPage";
import GraphViewVis from "./components/GraphViewVis";
import NoteView from "./components/NoteView";
import PrivacyPolicyPage from "./components/PrivacyPolicyPage";
import TermsAndConditionsPage from "./components/TermsAndConditionsPage";
import SurveyPage from "./components/SurveyPage";

const Layout = ({ children, onNewNote, username, profilePicture }) => {
  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  // Hide header on auth/landing pages
  const hideHeaderAuthPages = ["/signin", "/register", "/"].includes(location.pathname);

  // Hide header on app shell routes (desktop + mobile) so NoteView owns its own shell/header
  const hideHeaderAppShell = ["/newnote", "/app", "/profile"].includes(location.pathname);
  const hideHeaderGraph = location.pathname === "/graph";

  const hideHeader = hideHeaderAuthPages || hideHeaderAppShell || hideHeaderGraph;

  useEffect(() => {
    if (location.pathname === "/newnote") return;
    const active = document.activeElement;
    if (active && typeof active.blur === "function") {
      active.blur();
    }
  }, [location.pathname]);

  const isNoteEditorRoute = ["/app", "/newnote"].includes(location.pathname);
  const contentPadding = (hideHeader || isMobile || isNoteEditorRoute) ? "0" : "20px";

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      {!hideHeader && <Header />}
      <div style={{ flex: 1, overflow: "auto", padding: contentPadding, position: "relative" }}>
        {children}
      </div>
    </div>
  );
};

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (!token) {
      navigate("/signin");
    }
  }, [navigate]);
  return children;
};

function App() {
  const [refreshKey, setRefreshKey] = useState(0);
  const [selectedNote, setSelectedNote] = useState(null);

  const handleNewNote = () => {
    setSelectedNote(null);
    setRefreshKey((prev) => prev + 1); // Increment the key to trigger re-render
  };

  // Mock user data
  const username = "John Doe";
  const profilePicture = "/path/to/profile.jpg"; // Replace with actual profile picture path

  return (
    <Router>
      <Layout onNewNote={handleNewNote} username={username} profilePicture={profilePicture}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/register" element={<RegistrationPage />} />
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <NoteView key={refreshKey} selectedNote={selectedNote} setSelectedNote={setSelectedNote} onNewNote={handleNewNote} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/newnote"
            element={
              <ProtectedRoute>
                <NoteView key={refreshKey} selectedNote={selectedNote} setSelectedNote={setSelectedNote} onNewNote={handleNewNote} />
              </ProtectedRoute>
            }
          />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/graph" element={<GraphViewVis />} />
          <Route path="/privacy_policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms_and_conditions" element={<TermsAndConditionsPage />} />
          <Route path="/survey" element={<SurveyPage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
